import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography, Button, CircularProgress, IconButton, Chip } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import storylaneContext from '../Context/StoryLaneContext';

const VideoPlayer = ({ currentDemo, onScheduleDemo, isLoading }) => {
    const { videoURL } = useContext(storylaneContext);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    console.log('videoURL :- ', videoURL);

    useEffect(() => {
        // Reset iframe loaded state when URL changes
        if (videoURL) {
            setIframeLoaded(false);
        }
    }, [videoURL]);
    return (
        // <Box
        //     sx={{
        //         flex: 1,
        //         display: 'flex',
        //         flexDirection: 'column',
        //         backgroundColor: '#f9f9f9',
        //         overflow: 'hidden'
        //     }}
        // >

        //     {/* Video Content Area */}
        //     <Box
        //         sx={{
        //             flex: 1,
        //             display: 'flex',
        //             flexDirection: 'column',
        //             padding: 3,
        //             overflow: 'auto'
        //         }}
        //     >
        //         {currentDemo ? (
        //             <>
        //                 {/* Responsive Video Container with Aspect Ratio */}
        //                 <Box
        //                     sx={{
        //                         position: 'relative',
        //                         width: '100%',
        //                         paddingBottom: '56.25%', // 16:9 Aspect Ratio
        //                         backgroundColor: '#000',
        //                         borderRadius: 2,
        //                         overflow: 'hidden',
        //                         boxShadow: 3,
        //                         mb: 3
        //                     }}
        //                 >
        //                     {/* Loading Indicator */}
        //                     {(isLoading || !iframeLoaded) && (
        //                         <Box
        //                             sx={{
        //                                 position: 'absolute',
        //                                 top: 0,
        //                                 left: 0,
        //                                 right: 0,
        //                                 bottom: 0,
        //                                 display: 'flex',
        //                                 alignItems: 'center',
        //                                 justifyContent: 'center',
        //                                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
        //                                 zIndex: 1
        //                             }}
        //                         >
        //                             <CircularProgress size={60} />
        //                         </Box>
        //                     )}

        //                     {/* Video iframe */}
        //                     <iframe
        //                         src={currentDemo.url}
        //                         title={currentDemo.title}
        //                         style={{
        //                             position: 'absolute',
        //                             top: 0,
        //                             left: 0,
        //                             width: '100%',
        //                             height: '100%',
        //                             border: 'none'
        //                         }}
        //                         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        //                         allowFullScreen
        //                         onLoad={() => setIframeLoaded(true)}
        //                     />
        //                 </Box>

        //                 {/* Schedule Demo Button */}
        //                 <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        //                     <Button
        //                         variant="contained"
        //                         size="large"
        //                         onClick={onScheduleDemo}
        //                         sx={{
        //                             minWidth: 250,
        //                             py: 1.5,
        //                             fontSize: '1rem',
        //                             fontWeight: 600
        //                         }}
        //                     >
        //                         📅 Schedule Demo
        //                     </Button>
        //                 </Box>
        //             </>
        //         ) : (
        //             // Empty state when no demo is selected
        //             <Box
        //                 sx={{
        //                     flex: 1,
        //                     display: 'flex',
        //                     flexDirection: 'column',
        //                     alignItems: 'center',
        //                     justifyContent: 'center',
        //                     textAlign: 'center',
        //                     gap: 2
        //                 }}
        //             >
        //                 <PlayCircleOutlineIcon sx={{ fontSize: 100, color: '#bdbdbd' }} />
        //                 <Typography variant="h4" color="text.secondary" gutterBottom>
        //                     Welcome to Interactive Demos
        //                 </Typography>
        //                 <Typography variant="body1" color="text.secondary">
        //                     Select a demo from the left sidebar to begin
        //                 </Typography>
        //             </Box>
        //         )}
        //     </Box>
        // </Box>

        <Box sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {videoURL ? (
                <>
                    {/* Full Screen Video Container */}
                    <Box sx={{
                        flex: 1,
                        position: 'relative',
                        width: '100%',
                        height: '100%'
                    }}>
                        {/* Loading Indicator */}
                        {(isLoading || !iframeLoaded) && (
                            <Box sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 2
                            }}>
                                <CircularProgress />
                            </Box>
                        )}

                        {/* Video iframe - Full Screen */}
                        <iframe
                            src={videoURL || 'https://app.storylane.io/share/jxgdimyzx406'}
                            title="Demo"
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none'
                            }}
                            allow="fullscreen"
                            onLoad={() => setIframeLoaded(true)}
                        />
                    </Box>

                    {/* Schedule Demo Button - Floating */}
                    <Box sx={{
                        position: 'absolute',
                        bottom: 20,
                        right: 20,
                        zIndex: 10
                    }}>
                        <Button
                            variant="contained"
                            onClick={onScheduleDemo}
                            sx={{
                                bgcolor: 'primary.main',
                                '&:hover': { bgcolor: 'primary.dark' },
                                px: 3,
                                py: 1.5,
                                fontSize: '1rem',
                                fontWeight: 600,
                                borderRadius: 2,
                                boxShadow: 3
                            }}
                        >
                            📅 Schedule Demo
                        </Button>
                    </Box>
                </>
            ) : (
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    color: 'text.secondary'
                }}>
                    <PlayCircleOutlineIcon sx={{ fontSize: 80, mb: 2, color: 'primary.main' }} />
                    <Typography variant="h4" color="text.primary" gutterBottom>
                        Welcome to Interactive Demos
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Select a demo from the left sidebar to begin
                    </Typography>
                </Box>
            )}
        </Box>

    );
};

export default VideoPlayer;
